import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * SortableHeader
 * A clickable <th> for tables driven by a "field" / "-field" sortBy
 * string (the toggle logic already lives in each page's handleSortChange
 * — this component only renders the current direction, it doesn't own
 * the state).
 */
const SortableHeader = ({ field, label, sortBy, onSort, className }) => {
  const { t } = useTranslation();
  const isDesc = sortBy === `-${field}`;
  const isActive = sortBy === field || isDesc;

  return (
    <th
      className={`sortable-header ${className || ''}`}
      onClick={() => onSort(field)}
      role="button"
      tabIndex={0}
      aria-label={isActive ? t(isDesc ? 'table.sortDescending' : 'table.sortAscending') : undefined}
    >
      {label}
      {isActive && <span className="sort-arrow">{isDesc ? ' ↓' : ' ↑'}</span>}
    </th>
  );
};

export default SortableHeader;
